seedWebApp.controller('EmailsController', ['$scope', '$rootScope', '$uibModal', 'ToastService', 'TranslationService', 'EmailService',
    function ($scope, $rootScope, $uibModal, ToastService, TranslationService, EmailService) {
        console.log('emailsController');

        $scope.translation = TranslationService.getActiveTranslation();

        $scope.prefs = {
            name: 'EmailsGrid',
            sortByCol: null,
            canAdd: true,
            canEdit: true,
            canDelete: false,
        };

        $scope.idClass = function (item) {
            return 'agp-color';
        };

        $scope.triggerClass = function (item) {
            return 'btn btn-default btn-xs';
        };

        $scope.statusClass = function (item) {
            return 'Status_' + item;
        };

        $scope.sitPortalClass = function (item) {
            if (item == 5) {
                return 'sit-portal-aceito';
            }
            else if (item == 2) {
                return 'sit-portal-rejeitado';
            }
            else if (item == 4) {
                return 'sit-portal-waiting';
            }
        };

        $scope.columns = [
            { name: 'EmailID', display: 'Email', orderBy: 'asc', editable: false, width: 10, isKey: true, customClass: $scope.idClass },  //filterOptions: [] 
            { name: 'EmailName', display: 'Nome', editable: true, width: 15 },
            { name: 'EmailSubject', display: 'Assunto', editable: true, width: 15 },
            { name: 'EmailTrigger', display: 'Tipo Gatilho', editable: true, width: 5, customClass: $scope.triggerClass },
            { name: 'WhenStatusID', display: 'When Status', editable: true, width: 15, translationPrefix: 'Status_', tdClass: $scope.statusClass },
            { name: 'WhenSitPortal', display: 'When Sit Portal', editable: true, width: 15, translationPrefix: 'Sit_Portal_', tdClass: $scope.sitPortalClass },
            { name: 'EmailEnabled', display: 'Ativo', editable: true, width: 10, dataType: 'boolean' },
            { name: 'SendToCreator', display: 'Enviar Criador', editable: true, width: 10, dataType: 'boolean' },
            { name: 'SendToContactList', display: 'Enviar Cliente', editable: true, width: 10, dataType: 'boolean' },
            { name: 'SendToRepresentative', display: 'Enviar Vendedor', editable: true, width: 10, dataType: 'boolean' },
            { name: 'IncotermIDs', display: 'Incoterms', editable: true, width: 25 },

            /*            
            { name: 'ForeColor', display: 'Cor Fonte', filterOptions: [], editable: true, width: 15, dataType: 'color' },
            { name: 'BackColor', display: 'Cor Fundo', filterOptions: [], editable: true, width: 15, dataType: 'color' },                        
            */
        ];

        $scope.prefs.sortByCol = $scope.columns[0];
        $scope.prefs.sortByCol.orderReverse = false;

        $scope.loadService = EmailService.getEmails;
        $scope.resetService = EmailService.resetCache;
        //$scope.loadColumns = ContactService.getContactsColumns;      

        $scope.searchMode = function () {
            $scope.$broadcast('inputSearch', $scope.filterString);
        };

        $scope.doRefresh = function () {
            $scope.$broadcast('refreshServiceGrid');
        };

        $scope.toExcel = function () {
            $scope.$broadcast('toExcel', 'emails');
        };

        $scope.prefs.customEdit = function (item) {
            emailModalResult(openEmailModal(item));
        };

        $scope.doInsert = function () {
            emailModalResult(openEmailModal());
        };
        
        function openEmailModal (item) {
            return $uibModal.open({
                templateUrl: './SPA/Settings/Docs/emailModal.html' + seedWebApp.buildVersion,
                controller: 'EmailModalCtrl as ctrl',
                size: 'xl',
                resolve: {
                    item: function () {
                        return item ? item : {};
                    },
                    translation: function () {
                        return $scope.translation;
                    },
                    isEdit: function () {
                        return item ? true : false;
                    },
                }
            });
        }

        function emailModalResult(modalInstance) {
            modalInstance.result.then(function () {
                $scope.doRefresh();
            });
        }
    }
]);
